// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"c88f2d2a","453":"54292a4b","634":"19fe62d6"}[chunkId] + ".chunk.js";
};